import type { WelcomePoints } from './welcome-points-dialog';

// Guarda os pontos recebidos no cadastro até o usuário logar (via OTP) e ver o modal na home
const STORAGE_KEY_WELCOME_POINTS = 'pendingWelcomePoints';

export const savePendingWelcomePoints = (welcomePoints: WelcomePoints) => {
  try {
    localStorage.setItem(STORAGE_KEY_WELCOME_POINTS, JSON.stringify(welcomePoints));
  } catch {
    // storage indisponível: o modal apenas não será exibido
  }
};

export const getPendingWelcomePoints = (): WelcomePoints | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_WELCOME_POINTS);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as WelcomePoints;
    return parsed?.points > 0 ? parsed : null;
  } catch {
    return null;
  }
};

export const clearPendingWelcomePoints = () => {
  try {
    localStorage.removeItem(STORAGE_KEY_WELCOME_POINTS);
  } catch {
    // ignora
  }
};
